<script>
export default {
    props: ['courses', 'publicPage', 'getColor', 'url', 'isMobile'],
    methods: {
        blurOut(course)
        {
            if(this.courses.filter(x => x.hovered) == 0) {
                return false;
            }
            else if(course.hovered) {
                return false;
            }
            return true;
        },
    }
}
</script>
<template>
    <div class="CourseList-wrapper" :class="isMobile ? 'Courses-mobile' : ''">
        <div v-for="course in courses" class="CourseList-course-item"> 
            <div @mouseover="course.hovered = true" @mouseout="course.hovered = false" :class="blurOut(course) ? 'ImageGallery-grayscale' : 'ImageGallery-no-grayscale'" >
                <div class="position-relative">
                    <div class="CourseItem-img-area">
                        <img v-if="course.image_id" :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ course.image_name" />  
                        <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                    </div>
                    <h4 :style="{'background-color': getColor('background_color') }">{{ course.name }}</h4>
                </div>
                <div class="CourseItem-max-course">    
                     <i><span v-html="course.description.slice(0, 100) + '...'"></span></i>
                                <div class="margin-top-15">Max antal deltagare: {{ course.max_number_of_participents }} <span style="color: red" v-if="course.max_number_of_participents - course.number_of_approved_participants <= course.show_few_left_at_this_number">Fåtal platser kvar!</span></div>
                                <div>Pris: <b>{{ course.price }} kr</b></div>
                                <div>Kursstart: {{ course.course_start }}</div>
                                <div>Antal tillfällen: {{ course.number_of_occations }} st </div>               
                   
                </div>
            </div>              
        </div>
    </div>
</template>

<style scoped>
.Courses-btn{
        background-color: rgb(181, 205, 191);
    padding: 10px 20px;
    font-size: 14px;
    color: black;
    border: 0px solid lightgray;
    font-family: 'Raleway', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    cursor: pointer;
    }
    
    .Courses-btn:hover {
        filter: brightness(0.8);
    }

.CourseList-wrapper
    {
        display:flex;
        flex-wrap: wrap;
    }
    .CourseList-course-item
    {
        padding:10px; 
        margin: 20px;
        background: white;
        width: calc(33% - 60px);
        box-shadow: 1px 1px #ddd;
    }
    
    .Courses-mobile .CourseList-course-item
    {
        padding:0px; 
        margin: 20px 10px;
        background: white;
        width: calc(100% - 20px);
        box-shadow: 1px 1px #ddd;
    }

    .CourseItem-img-area
    {
        overflow: hidden;
        text-align: center;
        display: flex;
        align-items: flex-end;
    }

    .CourseItem-max-course
    {
        margin: 30px 10px 10px 10px;
        overflow:auto;
    }

    .CourseItem-wrapper
    {
        display:flex;
        flex-wrap: wrap;

    }

    .CourseItem-img-area i
    {
        display:block;
        padding-top: 40px;
        font-size: 60px;
        background-color:aliceblue;
        height: 100vh;
    }

    img
    {
        width: 100%;
    }

    h4{
        margin-bottom:0px;
        padding:10px;
        width: 50%;
        position: absolute;
        bottom: -20px;
        left: 10px;
        font-size: 14px;
    }

    
.ImageGallery-grayscale {
    filter:grayscale(80%);
    transition: ease-out 0.2s;
}

.ImageGallery-no-grayscale {
    filter:grayscale(0%);
    transition: ease-out 0.2s;
}

    @media only screen and (max-width: 1000px) {
        .CourseItem-img-area {
            height: auto;
            width: auto;
        }
        
        .CourseList-course-item
        {
            padding:10px; 
            margin: 30px;
            width: calc(100% - 80px);
        }       
    }
</style>